import { z } from 'zod';

const LiveParticipantSnapshotSchema = z.object({
  pid: z.string().max(100),
  stage: z.string().max(50).optional(),
  networkQuality: z.string().max(50).optional(),
  reconnecting: z.boolean().optional(),
  audioEnabled: z.boolean().optional(),
  videoEnabled: z.boolean().optional(),
});

const LiveQualityAlertSchema = z.object({
  pid: z.string().max(100),
  severity: z.string().max(50),
  message: z.string().max(300),
});

/** Moderator-side view of the room at send time. Present only in live mode (conference sidebar). */
export const LiveConferenceSnapshotSchema = z.object({
  capturedAt: z.string(),
  callStatus: z.string().max(50),
  viewerRole: z.string().max(50),
  participants: z.array(LiveParticipantSnapshotSchema).max(200),
  recentQualityAlerts: z.array(LiveQualityAlertSchema).max(50),
});

export type LiveConferenceSnapshot = z.infer<typeof LiveConferenceSnapshotSchema>;

export const ConferenceFocusSchema = z.object({
  kind: z.literal('conference'),
  conferenceIdentifier: z.number().int().positive(),
  live: LiveConferenceSnapshotSchema.optional(),
});

export type ConferenceFocus = z.infer<typeof ConferenceFocusSchema>;

/** What the user is looking at. Add a member here when another page adopts the support chat. */
export const SupportFocusSchema = z.discriminatedUnion('kind', [ConferenceFocusSchema]);

export type SupportFocus = z.infer<typeof SupportFocusSchema>;

export const TriniPageContextSchema = z.object({
  url: z.string(),
  pathname: z.string(),
  pageTitle: z.string(),
  topic: z.string().optional(),
  brandId: z.string().optional(),
  projectId: z.string().optional(),
  folderId: z.string().optional(),
  surveyId: z.string().optional(),
  focus: SupportFocusSchema.optional(),
  capturedAt: z.string(),
});

export type TriniPageContext = z.infer<typeof TriniPageContextSchema>;

export const TriniSubmitQueryExtensionSchema = z.object({
  agentType: z.literal('trini'),
  pageContext: TriniPageContextSchema,
});

export type TriniSubmitQueryExtension = z.infer<typeof TriniSubmitQueryExtensionSchema>;
